import React from 'react'
import {Icon} from '@chakra-ui/react'

const GridIconA = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props}>
            <rect
                x="2.5"
                y="8.5"
                width="14"
                height="23"
                rx="0.5"
                fill="currentColor"
                stroke="currentColor"
            />
            <rect x="31" y="14.5" width="6.5" height="11" rx="0.5" stroke="currentColor" />
            <rect x="22" y="14.5" width="6.5" height="11" rx="0.5" stroke="currentColor" />
        </Icon>
    )
}

export default GridIconA
